import * as t from 'ts-schema';
import { registerQuery } from 'data-fetching-client';
import { getCollections } from '../../clients/qualityClient';
import { collectionsResponseSchema } from '../types/Collection';
export const GET_COLLECTIONS_QUERY = registerQuery({
  fieldName: 'collections',
  args: ['appContext', 'offeringType'],
  fetcher: ({
    appContext,
    offeringType
  }) => getCollections({
    appContext,
    offeringType
  }).then(resp => t.assert(collectionsResponseSchema, resp))
});